import React from 'react';
import GuestHeader from '../components/guest-header';

const OrderLayout = ({ children, scrollable = false, document = false }) => {
  const pageClass = [
    'duo-caisse-page',
    document ? 'duo-caisse-page--document' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const mainClass = [
    'duo-caisse-main',
    scrollable ? 'duo-caisse-main--scroll' : '',
    document ? 'duo-caisse-main--document' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={pageClass}>
      <GuestHeader />
      <section className={mainClass}>{children}</section>
    </div>
  );
};

export default OrderLayout;
